import { constants } from "crypto";
import Constants from '../models/constants/Constants'
export default

    class ConfigurationController {

    constructor(resource) {
        this._resource = resource;
    }


    getAllConfigurationByClientId(clientId) {
        return this._resource(`configuration/${clientId}`)
            .get()
            .then(res => res.json())
            .catch(error => console.log(error))
    }


    async update(configuration, client_id) {
        return await this._resource(`configuration/${client_id}`)
            .update(configuration)
            .then(res => res.json());
    }

    async getAll() {
        let response;
        try {
            response = await this._resource(`configuration/`).get()
        } catch (error) {
            console.log(error)
        }
        return response.json()
    }

    async getConfigMaps() {
        let response;
        try {
            response = await this._resource(`configurations/map`).get()
        } catch (error) {
            console.log(error)
        }
        return response.json()
    }
}